export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/tickets.b9637645-f2979a.png";